import { render, staticRenderFns } from "./Options.vue?vue&type=template&id=074d6996&scoped=true"
import script from "./Options.vue?vue&type=script&lang=ts"
export * from "./Options.vue?vue&type=script&lang=ts"
import style0 from "./Options.vue?vue&type=style&index=0&id=074d6996&prod&scoped=true&lang=scss"
import style1 from "./Options.vue?vue&type=style&index=1&id=074d6996&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074d6996",
  null
  
)

export default component.exports